var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("MainLayout", [
    _c(
      "div",
      {
        staticClass: "container mw-960",
        attrs: { slot: "action-bar" },
        slot: "action-bar"
      },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c(
              "h5",
              {
                staticClass:
                  "action-header typography--headline typography--color-secondary pt-1 pl-10-mobile pr-10-mobile"
              },
              [_vm._v(_vm._s(_vm.formattedClassName))]
            )
          ])
        ])
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "container mw-960 mt-15",
        attrs: { slot: "layout-body" },
        slot: "layout-body"
      },
      [
        _vm.loading
          ? _c("div", { staticClass: "row pt-3" }, [
              _c(
                "div",
                { staticClass: "col-12 text-center" },
                [
                  _c("LoadingBounce"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "typography--body-2 typography--color-disabled pb-5"
                    },
                    [_vm._v(_vm._s(_vm.$t("common.loading")))]
                  )
                ],
                1
              )
            ])
          : _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "row sort-subject-menu" },
                [
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "select-subject-dropdown mnv-dropdown",
                      attrs: {
                        text: _vm.getTranslatedName(
                          _vm.subjectMap[_vm.selectedSubjectId]
                        )
                      }
                    },
                    _vm._l(_vm.subjectIds, function(value, index) {
                      return _c(
                        "b-dropdown-item",
                        {
                          key: index,
                          on: {
                            click: function($event) {
                              _vm.selectedSubjectId = parseInt(value, 10)
                              _vm.sortAssignments()
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm.getTranslatedName(_vm.subjectMap[value])
                              ) +
                              "\n          "
                          )
                        ]
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sort-type clickable mr-12 typography--color-secondary",
                      on: {
                        click: function($event) {
                          _vm.sortType = "recent"
                          _vm.sortAssignments()
                        }
                      }
                    },
                    [
                      _vm.sortType === "recent"
                        ? _c("img", {
                            attrs: { src: "/static/images/radio-btn-01.svg" }
                          })
                        : _c("img", {
                            attrs: { src: "/static/images/radio-btn-02.svg" }
                          }),
                      _vm._v(
                        " " + _vm._s(_vm.$t("reports.sort_new_assignment"))
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "sort-type clickable typography--color-secondary",
                      on: {
                        click: function($event) {
                          _vm.sortType = "score"
                          _vm.sortAssignments()
                        }
                      }
                    },
                    [
                      _vm.sortType === "score"
                        ? _c("img", {
                            attrs: { src: "/static/images/radio-btn-01.svg" }
                          })
                        : _c("img", {
                            attrs: { src: "/static/images/radio-btn-02.svg" }
                          }),
                      _vm._v(" " + _vm._s(_vm.$t("reports.sort_achievement")))
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "col-12" }, [
                _c(
                  "div",
                  { staticClass: "card-row" },
                  [
                    _c("TableCard", { staticClass: "report-result" }, [
                      _c(
                        "div",
                        {
                          staticClass: "mb-8",
                          attrs: { slot: "table-action" },
                          slot: "table-action"
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "typography--content-body pb-3" },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.getShortenedString(
                                      _vm.currentStudent.name,
                                      30
                                    )
                                  ) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "float-right typography--caption typography--color-secondary pb-2"
                            },
                            [
                              _vm.assignmentsBySubjects[_vm.selectedSubjectId]
                                ? _c("span", [
                                    _vm._v(
                                      "\n                  " +
                                        _vm._s(
                                          _vm.$t(
                                            "reports.assignment_count_cnt",
                                            {
                                              cnt:
                                                _vm.assignmentsBySubjects[
                                                  _vm.selectedSubjectId
                                                ].length
                                            }
                                          )
                                        ) +
                                        "\n                "
                                    )
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("reports.assignment_count_cnt", {
                                          cnt: 0
                                        })
                                      )
                                    )
                                  ])
                            ]
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "table",
                        {
                          staticClass: "table",
                          attrs: { slot: "table" },
                          slot: "table"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary text-left pl-10"
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("reports.table.card_name"))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _c("div", [
                                    _vm._v(
                                      _vm._s(_vm.$t("reports.table.score"))
                                    )
                                  ])
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.table.class_rank")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.table.correct_count")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("reports.table.duration")) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(
                                        _vm.$t("reports.assignment_period")
                                      ) +
                                      "\n                  "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "th",
                                {
                                  staticClass:
                                    "align-top typography--color-secondary"
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(_vm.$t("reports.see_result")) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c(
                            "tbody",
                            [
                              (
                                _vm.assignmentsBySubjects[
                                  _vm.selectedSubjectId
                                ] || []
                              ).length > 0
                                ? _vm._l(
                                    _vm.assignmentsBySubjects[
                                      _vm.selectedSubjectId
                                    ] || [],
                                    function(asmt, index) {
                                      return _c("tr", { key: index }, [
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-middle typography--body-3 card-info-cell pl-10"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "align-middle clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStudentAssignmentPreview(
                                                      asmt
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                        " +
                                                    _vm._s(
                                                      _vm.getShortenedString(
                                                        asmt.assigned_card
                                                          .title,
                                                        30
                                                      )
                                                    ) +
                                                    "\n                      "
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center",
                                                class: {
                                                  "typography--color-alert":
                                                    _vm.getScoreRatio(
                                                      asmt.currentStudentSubmission
                                                    ) <= 20
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm.getScoreRatio(
                                                        asmt.currentStudentSubmission
                                                      ) || 0
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "typography--font-weight-bold"
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                        " +
                                                        _vm._s(
                                                          _vm.getClassScoreRank(
                                                            asmt
                                                              .currentStudentSubmission
                                                              .correct_quiz_count,
                                                            asmt.classScores
                                                          )
                                                        ) +
                                                        _vm._s(
                                                          _vm.$t(
                                                            "reports.rank_suffix"
                                                          )
                                                        ) +
                                                        "\n                      "
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  " / " +
                                                    _vm._s(
                                                      _vm.getNumStrTwoDigit(
                                                        asmt.submissions.length
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "typography--font-weight-bold correct-quiz-count"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.getNumStrTwoDigit(
                                                          asmt
                                                            .currentStudentSubmission
                                                            .correct_quiz_count
                                                        )
                                                      )
                                                    )
                                                  ]
                                                ),
                                                _vm._v(
                                                  "\n                        / " +
                                                    _vm._s(
                                                      asmt
                                                        .currentStudentSubmission
                                                        .quiz_count
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        asmt.currentStudentSubmission
                                          .is_submitted
                                          ? _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 text-center"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("duration")(
                                                        asmt
                                                          .currentStudentSubmission
                                                          .duration
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          : _c(
                                              "td",
                                              {
                                                staticClass:
                                                  "align-top typography--body-3 typography--color-disabled text-center"
                                              },
                                              [_vm._v("-")]
                                            ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-top typography--body-3 text-center"
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formattedDate(
                                                  asmt.start_date
                                                )
                                              ) +
                                                " - " +
                                                _vm._s(
                                                  _vm.formattedDate(
                                                    asmt.due_date
                                                  )
                                                )
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "td",
                                          {
                                            staticClass:
                                              "align-top typography--body-3 text-center"
                                          },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "btn-outline-rectangle clickable",
                                                on: {
                                                  click: function($event) {
                                                    return _vm.openStudentAssignmentPreview(
                                                      asmt
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm.$t(
                                                      "reports.assignment_result"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ])
                                    }
                                  )
                                : [
                                    _c("tr", [
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "td",
                                        {
                                          staticClass:
                                            "align-top typography--body-3 typography--color-disabled text-center"
                                        },
                                        [_vm._v("-")]
                                      )
                                    ])
                                  ]
                            ],
                            2
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ])
            ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a6e2e2a4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a6e2e2a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/classes/views/StudentReport.vue
// module id = N5uh
// module chunks = 1